<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      双拥街站<br>
站点介绍<br>
双拥街站位于深圳市龙岗区双拥街路下方，车站主体呈南北走向，南接平湖站，是10号线的折返站。 双拥街站色彩基调以黄色为主，为地下二层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有4个出入口，临近深圳市龙岗区第五人民医院，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:19	23:00	10号线	3分40秒	6分钟<br>
双拥街	--	--	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:19	23:00	10号线	4分50秒	7分钟<br>
双拥街	--	--	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:19	00:00	10号线	4分50秒	7分钟<br>
双拥街	--	--	10号线	4分50秒	7分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
双拥街南侧<br><br>
B出入口:<br>
双拥街北侧（东）<br><br>
C出入口:<br>
双拥街北侧、深圳市龙岗区第五人民医院<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 双拥街地铁站<br>
M318、M573、莞915<br><br>
B出入口:<br>
公交站名： 双拥街顺昌路口<br>
M318、M573<br><br>
C出入口:<br>
公交站名： 双拥街地铁站<br>
M318、M573<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>